import { ControlListResetFiltersButton } from "@/features/controls/components/control-list-reset-filters-button";
import { ControlListResultPopover } from "@/features/controls/components/control-list-result-popover";
import { ControlListSearchBar } from "@/features/controls/components/control-list-search-bar";
import { ControlListStakePopover } from "@/features/controls/components/control-list-stake-popover";
import { ControlListTagsFilters } from "@/features/controls/components/control-list-tags-filters";
import type { ControlListItem, ControlTag } from "@/models/control.model";
import type { Currency } from "@/shared/value-objects/currency.vo";
import { Table } from "@spz/ui/components/table";
import { DataTableBody } from "@spz/ui/components/table/data-table-body";
import { DataTableHeader } from "@spz/ui/components/table/data-table-header";
import { DataTablePagination } from "@spz/ui/components/table/data-table-pagination";
import type { Table as TanStackTable } from "@tanstack/react-table";
import type { FC } from "react";

type ControlListDataTableProps = {
  table: TanStackTable<ControlListItem>;
  uniqueTags: ControlTag[];
  isLoading: boolean;
  currency?: Currency;
};

export const ControlListDataTable: FC<ControlListDataTableProps> = ({
  table,
  uniqueTags,
  isLoading,
  currency,
}) => {
  return (
    <>
      <div className="mb-4 flex items-center gap-2">
        <div className="w-1/4">
          <ControlListSearchBar table={table} />
        </div>

        <ControlListResultPopover table={table} />

        <ControlListStakePopover table={table} currency={currency} />

        <ControlListTagsFilters table={table} uniqueTags={uniqueTags} />

        <ControlListResetFiltersButton table={table} />
      </div>

      <Table
        className="overflow-auto w-full border-collapse border-spacing-0 bg-white"
        data-testid="control-list-table"
      >
        <DataTableHeader table={table} testIdPrefix="control-list-table" />
        <DataTableBody
          table={table}
          isLoading={isLoading}
          data-testid="control-list-tbody"
          testIdPrefix="control-list-row"
        />
      </Table>
      <DataTablePagination
        table={table}
        entityLabel="pagination_entity_controls"
        isLoading={isLoading}
      />
    </>
  );
};
